import settings from '@/settings'

let pegarComprasCashPosto = (headers, data) => {
  let url = `${settings.apetrusApi}/compras/compras-de-cashposto/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let limite = (headers, data) => {
  // GET, PUT, POST, DELETE
  let url = `${settings.apetrusApi}/compras/limite/`
  const request = {
    method: data.method,
    mode: 'cors',
    headers: headers
  }

  if (data.parametros) {
    Object.keys(data.parametros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
    })
  }

  if (data.method === 'GET') {
    request.cache = 'default'
  } else request.body = JSON.stringify(data.body)

  return fetch(url, request)
}

const deAssinatura = (headers, data) => {
  let url = `${settings.apetrusApi}/compras/assinatura/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  pegarComprasCashPosto,
  limite,
  deAssinatura
}
